import {useContext} from 'react'
import {createResponseContext, initialQueryResponse, initialQueryState, PaginationState} from '../../../../../_metronic/helpers'
import {User} from './_models'

// This page (the admin Bookings list) never actually mounts a
// <QueryResponseProvider> - UsersList.tsx fetches booking data itself,
// directly, via a real endpoint (GET /admin/bookings in UsersTable.tsx).
// The context below previously came with a QueryResponseProvider component
// that called getUsers()/GET /users/query, an endpoint that doesn't exist
// on the backend and was never reachable from this page anyway since the
// provider was never mounted - removed as dead legacy code from the
// Metronic admin template.
//
// The context and the hooks below are kept: several still-live components
// on this page (ListViewProvider, UsersListGrouping, UserEditModalForm,
// UsersListFilter) import these hooks and read them off the context's
// static default value (no live Provider backs them here), so removing the
// hooks themselves would break those imports.
const QueryResponseContext = createResponseContext<User>(initialQueryResponse)

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const {response} = useQueryResponse()
  if (!response) {
    return []
  }

  return response?.data || []
}

const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }

  return response.payload.pagination
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {useQueryResponse, useQueryResponseData, useQueryResponsePagination, useQueryResponseLoading}
